export default __webpack_public_path__ + "static/media/graphCSV.19b99d6c.png";